import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auto-login-callback',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {

  public showSpinner = true;

  constructor(private router: Router) {
  }

  ngOnInit() {
    // This will execute after guards and app component.
    // 1) App component will start auth process.
    // 2) Guard will delay this component until auth finishes.
    // 3) This component loads, and immediately navigates elsewhere.
    this.router.navigateByUrl('home');
  }
}
